export const nutritionTools = [

    {
        slug: "bmi-nguoi-lon",
        name: "BMI người lớn",
        shortName: "BMI",
        group: "Cân nặng & cơ thể",
        description: "Tính chỉ số khối cơ thể từ cân nặng và chiều cao.",
        formula: "BMI = cân nặng (kg) / chiều cao² (m²)",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" }
        ]
    },

    {
        slug: "rmr-mifflin",
        name: "RMR Mifflin–St Jeor",
        shortName: "RMR",
        group: "Năng lượng",
        description: "Ước tính năng lượng chuyển hóa lúc nghỉ ở người lớn.",
        formula: "Nam: 9,99W + 6,25H − 4,92A + 5. Nữ: 9,99W + 6,25H − 4,92A − 161.",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" },
            { key: "age", label: "Tuổi", unit: "năm", type: "number" },
            {
                key: "sex",
                label: "Giới tính",
                type: "select",
                options: [
                    { value: "male", label: "Nam" },
                    { value: "female", label: "Nữ" }
                ]
            }
        ]
    },

    {
        slug: "nang-luong-hoat-dong",
        name: "Năng lượng theo mức hoạt động",
        shortName: "Energy",
        group: "Năng lượng",
        description: "Ước tính nhu cầu năng lượng từ RMR Mifflin–St Jeor và hệ số hoạt động.",
        formula: "Năng lượng ước tính = RMR × hệ số hoạt động.",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" },
            { key: "age", label: "Tuổi", unit: "năm", type: "number" },
            {
                key: "sex",
                label: "Giới tính",
                type: "select",
                options: [
                    { value: "male", label: "Nam" },
                    { value: "female", label: "Nữ" }
                ]
            },
            {
                key: "activity",
                label: "Mức hoạt động",
                type: "select",
                options: [
                    { value: "sedentary", label: "Ít hoạt động" },
                    { value: "low", label: "Hoạt động thấp" },
                    { value: "active", label: "Hoạt động" },
                    { value: "very", label: "Hoạt động nhiều" }
                ]
            }
        ]
    },

    {
        slug: "can-nang-ly-tuong-devine",
        name: "Cân nặng lý tưởng Devine",
        shortName: "IBW",
        group: "Cân nặng & cơ thể",
        description: "Ước tính cân nặng lý tưởng theo chiều cao và giới tính.",
        formula: "Nam: 50 + 2,3 kg mỗi inch trên 5 ft. Nữ: 45,5 + 2,3 kg mỗi inch trên 5 ft.",
        fields: [
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" },
            {
                key: "sex",
                label: "Giới tính",
                type: "select",
                options: [
                    { value: "male", label: "Nam" },
                    { value: "female", label: "Nữ" }
                ]
            }
        ]
    },

    {
        slug: "can-nang-hieu-chinh",
        name: "Cân nặng hiệu chỉnh",
        shortName: "AdjBW",
        group: "Cân nặng & cơ thể",
        description: "Tính cân nặng hiệu chỉnh từ cân nặng thực tế và cân nặng lý tưởng.",
        formula: "AdjBW = IBW + 0,4 × (Actual BW − IBW)",
        fields: [
            { key: "actualWeight", label: "Cân nặng thực tế", unit: "kg", type: "number" },
            { key: "idealWeight", label: "Cân nặng lý tưởng", unit: "kg", type: "number" }
        ]
    },

    {
        slug: "ty-le-vong-eo-chieu-cao",
        name: "Tỷ lệ vòng eo / chiều cao",
        shortName: "WHtR",
        group: "Cân nặng & cơ thể",
        description: "Tính tỷ lệ vòng eo so với chiều cao.",
        formula: "WHtR = vòng eo / chiều cao",
        fields: [
            { key: "waist", label: "Vòng eo", unit: "cm", type: "number" },
            { key: "height", label: "Chiều cao", unit: "cm", type: "number" }
        ]
    },

    {
        slug: "phan-tram-thay-doi-can-nang",
        name: "% thay đổi cân nặng",
        shortName: "Weight Change",
        group: "Theo dõi cân nặng",
        description: "Tính phần trăm thay đổi giữa cân nặng trước và hiện tại.",
        formula: "% thay đổi = (cân nặng hiện tại − cân nặng trước) / cân nặng trước × 100",
        fields: [
            { key: "oldWeight", label: "Cân nặng trước", unit: "kg", type: "number" },
            { key: "currentWeight", label: "Cân nặng hiện tại", unit: "kg", type: "number" }
        ]
    },

    {
        slug: "nang-luong-kcal-kg",
        name: "Năng lượng theo kcal/kg",
        shortName: "kcal/kg",
        group: "Năng lượng",
        description: "Tính tổng kcal từ cân nặng và hệ số kcal/kg do người dùng nhập.",
        formula: "Tổng kcal/ngày = cân nặng × kcal/kg",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "factor", label: "Hệ số năng lượng", unit: "kcal/kg/ngày", type: "number" }
        ]
    },

    {
        slug: "protein-g-kg",
        name: "Protein theo g/kg",
        shortName: "Protein",
        group: "Protein & macro",
        description: "Tính lượng protein từ cân nặng và hệ số g/kg do người dùng nhập.",
        formula: "Protein (g/ngày) = cân nặng × hệ số protein (g/kg/ngày)",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "factor", label: "Hệ số protein", unit: "g/kg/ngày", type: "number" }
        ]
    },

    {
        slug: "nuoc-ml-kg",
        name: "Nước theo mL/kg",
        shortName: "Fluid",
        group: "Nước",
        description: "Tính thể tích từ cân nặng và hệ số mL/kg do người dùng nhập.",
        formula: "Thể tích = cân nặng × hệ số mL/kg",
        fields: [
            { key: "weight", label: "Cân nặng", unit: "kg", type: "number" },
            { key: "factor", label: "Hệ số nước", unit: "mL/kg", type: "number" }
        ]
    },

    {
        slug: "chia-macro",
        name: "Chia carbohydrate / protein / fat",
        shortName: "Macro Split",
        group: "Protein & macro",
        description: "Chuyển tỷ lệ phần trăm năng lượng thành gram carbohydrate, protein và fat.",
        formula: "Carb 4 kcal/g, protein 4 kcal/g, fat 9 kcal/g.",
        fields: [
            { key: "calories", label: "Tổng năng lượng", unit: "kcal", type: "number" },
            { key: "carbPercent", label: "Carbohydrate", unit: "%", type: "number" },
            { key: "proteinPercent", label: "Protein", unit: "%", type: "number" },
            { key: "fatPercent", label: "Fat", unit: "%", type: "number" }
        ]
    },

    {
        slug: "kcal-tu-macro",
        name: "Tính kcal từ macro",
        shortName: "Macro kcal",
        group: "Protein & macro",
        description: "Tính tổng năng lượng từ gram carbohydrate, protein và chất béo.",
        formula: "kcal = carb × 4 + protein × 4 + fat × 9",
        fields: [
            { key: "carbs", label: "Carbohydrate", unit: "g", type: "number" },
            { key: "protein", label: "Protein", unit: "g", type: "number" },
            { key: "fat", label: "Fat", unit: "g", type: "number" }
        ]
    },

    {
        slug: "doi-kcal-kj",
        name: "Đổi kcal / kJ",
        shortName: "kcal ↔ kJ",
        group: "Quy đổi",
        description: "Chuyển đổi giữa kilocalorie và kilojoule.",
        formula: "1 kcal = 4,184 kJ",
        fields: [
            { key: "value", label: "Giá trị", unit: "", type: "number" },
            {
                key: "direction",
                label: "Chuyển đổi",
                type: "select",
                options: [
                    { value: "kcal-to-kj", label: "kcal → kJ" },
                    { value: "kj-to-kcal", label: "kJ → kcal" }
                ]
            }
        ]
    },

    {
        slug: "doi-kg-lb",
        name: "Đổi kg / lb",
        shortName: "kg ↔ lb",
        group: "Quy đổi",
        description: "Chuyển đổi cân nặng giữa kilogram và pound.",
        formula: "1 kg ≈ 2,20462 lb",
        fields: [
            { key: "value", label: "Giá trị", unit: "", type: "number" },
            {
                key: "direction",
                label: "Chuyển đổi",
                type: "select",
                options: [
                    { value: "kg-to-lb", label: "kg → lb" },
                    { value: "lb-to-kg", label: "lb → kg" }
                ]
            }
        ]
    }
];


export const nutritionGroups = [
    "Tất cả",
    "Cân nặng & cơ thể",
    "Theo dõi cân nặng",
    "Năng lượng",
    "Protein & macro",
    "Nước",
    "Quy đổi"
];


export const getNutritionTool = (slug) =>
    nutritionTools.find(
        (item) =>
            item.slug === slug
    );
